import { CanActivate, CanActivateChild, CanLoad, Router, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';
import { Role } from '../Roles';

@Injectable()
export class AccountGuard implements CanActivateChild {

    constructor(private router: Router, private authService: AuthService) {
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.authService.isLoggedIn) {
            return true;
        }
        if (state.url === '/accounts/change-password' && this.authService.isLoggedIn) {
            return true;
        }
        switch (this.authService.userRole) {
            case Role.Mentee:
             //this.router.navigate(['/mentee/dashboard']);
             this.router.navigate(['/mentee/questions']);
              break;
             case Role.Mentor:
              //this.router.navigate(['/mentor/dashboard']);
              this.router.navigate(['/mentor/questions']);

              break;
              case Role.Admin:
               this.router.navigate(['/admin/dashboard']);
               break;
            default:
             this.router.navigate(['/']);
              break;
          }
        // this.router.navigate(['/']);
        return false;
    }
}
